import { BindingRef } from '../../core/template.schemas';

/**
 * Generates dynamic key from binding reference.
 * 
 * Args:
 *     ref: Binding reference object
 * 
 * Returns:
 *     String key for dynamic value lookup
 */
export function dynamicKey(ref: BindingRef): string {
  if (ref.kind === 'slot') {
    return `slots.${ref.slotId}.${ref.attributePath}`;
  } else if (ref.kind === 'selector') {
    return `selectors.${ref.selectorId}`;
  } else if ((ref as any).kind === 'override') {
    return `overrides.${(ref as any).overrideKey}`;
  }
  
  // Fallback for unknown binding types
  return 'unknown';
}

/** Override values mapped by dynamic keys */
export type Overrides = Record<string, any>;
